import { createRoutine } from 'redux-saga-routines'

export const SET = 'MOVIMIENTOS/SET'
export const CONTENT = createRoutine('MOVIMIENTOS/CONTENT')
export const GET = createRoutine('MOVIMIENTOS/GET')
